import React from 'react';

interface Publication {
    title: string;
    source: string;
    icon: string;
    link: string;
}

interface PublicationListProps {
    publications: Publication[];
    className?: string;
}

export const PublicationList: React.FC<PublicationListProps> = ({
    publications,
    className = '',
}) => {
    return (
        <div className={`researcher-publications ${className}`}>
            {publications.map((pub, index) => (
                <a
                    key={index}
                    href={pub.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="researcher-pub"
                >
                    <div className="researcher-pub-icon">{pub.icon}</div>
                    <div className="researcher-pub-info">
                        <div className="researcher-pub-title">{pub.title}</div>
                        <div className="researcher-pub-source">{pub.source}</div>
                    </div>
                    <div className="researcher-pub-arrow">→</div>
                </a>
            ))}
        </div>
    );
};

export default PublicationList;
